
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/workspaceRightPanel/components/tabLabelWithIcon.scss.css.virtualfile';
        module.exports = {"label":"_label_1ssxh_1","text":"_text_1ssxh_7"};